import { render, staticRenderFns } from "./OrderLaundry.vue?vue&type=template&id=e40a8978&scoped=true"
import script from "./OrderLaundry.vue?vue&type=script&lang=js"
export * from "./OrderLaundry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40a8978",
  null
  
)

export default component.exports